import PropTypes from 'prop-types';

const InvestigationsSection = ({ investigations }) => {
  return (
    <div className="mt-2">
      <div className="bg-purple-50 rounded-md p-4">
        <h4 className="text-sm font-medium text-purple-900 mb-2">Suggested Investigations</h4>
        <ul className="list-disc list-inside space-y-1">
          {investigations.map((investigation, index) => (
            <li 
              key={index} 
              className="text-sm text-purple-800 cursor-pointer hover:text-purple-600"
              onClick={() => {
                // Dispatch custom event to set input value
                window.dispatchEvent(new CustomEvent('setInputValue', {
                  detail: { value: investigation }
                }));
              }}
            >
              {investigation}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

InvestigationsSection.propTypes = {
  investigations: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default InvestigationsSection; 